import React from "react";
import styled from "styled-components";

const Section = styled.section`
  background: #fff;
  padding: 64px 0 48px 0;
  border-bottom: 1.5px solid #222;
`;

const Title = styled.h2`
  font-size: 2rem;
  font-weight: 800;
  color: #222;
  text-align: center;
  margin-bottom: 32px;
  letter-spacing: 1px;
`;

const ServicesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 32px;
  max-width: 900px;
  margin: 0 auto;
  @media (max-width: 600px) {
    grid-template-columns: 1fr;
    gap: 18px;
    padding: 0 8px;
  }
`;

const ServiceCard = styled.div`
  background: #f8f9fa;
  border: 1.5px solid #222;
  border-radius: 18px;
  padding: 32px 20px;
  text-align: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);
  @media (max-width: 600px) {
    padding: 18px 8px;
  }
`;

const ServiceTitle = styled.h3`
  font-size: 1.18rem;
  font-weight: 700;
  color: #b28767;
  margin-bottom: 14px;
  letter-spacing: 0.5px;
  @media (max-width: 600px) {
    font-size: 1rem;
    margin-bottom: 8px;
  }
`;

const ServiceList = styled.ul`
  text-align: left;
  font-size: 1rem;
  color: #444;
  margin: 0;
  padding-left: 18px;
  line-height: 1.6;
`;

const Services = () => (
  <Section id="servicos">
    <Title>Serviços</Title>
    <ServicesGrid>
      <ServiceCard>
        <ServiceTitle>Assessoria Administrativa</ServiceTitle>
        <ServiceList>
          <li>
            Vida Legal da Instituição de Ensino (tramitação de processos de
            credenciamento, autorização, reconhecimento e renovações)
          </li>
          <li>
            Planejamento estratégico institucional (definição de metas,
            indicadores e planos de ação)
          </li>
          <li>
            Organização de processos administrativos (fluxos de secretaria,
            matrícula, comunicação interna)
          </li>
          <li>
            Gestão financeira e orçamentária (apoio em planilhas, prestação de
            contas, captação de recursos e parcerias)
          </li>
          <li>
            Suporte em processos legais e regulatórios (licenças, corpo de
            bombeiros, alvarás, autorizações sanitárias)
          </li>
          <li>
            Capacitação administrativa (treinamentos para secretarias, equipes
            de gestão e suporte técnico)
          </li>
        </ServiceList>
      </ServiceCard>
      <ServiceCard>
        <ServiceTitle>Assessoria Pedagógica</ServiceTitle>
        <ServiceList>
          <li>
            Elaboração e atualização de currículos e matrizes alinhados à
            BNCC/FGB/IFAs e legislações
          </li>
          <li>
            Construção e atualização dos documentos base da instituição de
            ensino (PPP/PPCs e Regimento Escolar)
          </li>
          <li>
            Formação continuada de professores (metodologias ativas, avaliação,
            inclusão, inovação)
          </li>
          <li>
            Orientação em avaliação institucional (planos de ensino,
            metodologias de acompanhamento e feedback)
          </li>
          <li>
            Projetos pedagógicos diferenciados (interdisciplinares,
            socioemocionais, culturais e tecnológicos)
          </li>
          <li>
            Assessoria em metodologias digitais e híbridas (VLE, plataformas
            educacionais, tecnologias emergentes)
          </li>
          <li>
            Monitoramento da aprendizagem (instrumentos de diagnóstico,
            acompanhamento de desempenho, estratégias de recuperação)
          </li>
        </ServiceList>
      </ServiceCard>
      <ServiceCard>
        <ServiceTitle>Serviços Integrados</ServiceTitle>
        <ServiceList>
          <li>
            Consultoria em comunicação institucional (apoio em marketing
            educacional, identidade visual e engajamento da comunidade)
          </li>
          <li>
            Organização de eventos acadêmicos e institucionais (semanas
            pedagógicas, feiras, congressos)
          </li>
          <li>
            Mediação entre escolas e órgãos reguladores (CEE, NRE, SEED,
            conselhos municipais)
          </li>
          <li>
            Projetos de inovação e sustentabilidade (implantação de práticas
            verdes, programas de responsabilidade social)
          </li>
          <li>
            Apoio a lideranças educacionais (mentoria para gestores,
            coordenadores pedagógicos e mantenedores)
          </li>
        </ServiceList>
      </ServiceCard>
    </ServicesGrid>
  </Section>
);

export default Services;
